<template>
	<div class="dropper" @click="click" @dragover="dragover" :class="{dragging:dragging}" @dragleave="dragleave"  @drop="drop">
		<slot/>
	</div>
</template>
<script>
	export default {
		name:"dropper",
		props:["context"],
		data(){
			return {
				dragging:false
			}
		},
		methods:{
			click(v){
				this.$emit('click',v);
			},
			dragover(e){
				this.dragging = true;
				e.preventDefault();
				//console.log('dragover',e)
			},
			dragleave(e){
				this.dragging = false;
				e.preventDefault();
				//console.log('dragleave',e)
			},
			drop(e){
				this.dragging = false;
				let {context} = this;
				if(e.dataTransfer){
					/*console.log("DROP :",e.dataTransfer.getData("data"),"TO:",context)*/
					this.$emit('onDrop', JSON.parse(e.dataTransfer.getData("data")),context);
				}
			}
		}
	}
</script>
<style scoped>
	.dropper{
		height:100%;
		width:100%;
	}
	.dragging{
		/*outline:5px dashed red ;*/
	}
</style>